import React, { useContext, useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { globalFileIcon } from "../../../axiosInstance";
import { getProductsByCategory, setProducts } from "../../server/Product.js";
import { getBySlug } from "../../server/Category";
import "./SubNavbar.scss";

const SubNavbar = ({
  fatherSlug,
  currentSubCategory,
  currentCategories,
  handleSubCategoryClick,
  level = 1,
}) => {
  const { stationId } = useSelector((state) => ({
    stationId: state.user.stationId,
  }));

  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [children, setChildren] = useState([]);

  const currentCategory = pathname.startsWith("/category/")
    ? pathname.split("/")[level + 2]
    : null;

const currentAbortController = useRef(null);

const handleCategoryClick = (slug) => {
  handleSubCategoryClick(slug);
  if (currentAbortController.current) {
    currentAbortController.current.abort();
  }

  const abortController = new AbortController();
  currentAbortController.current = abortController;

  setChildren(
    currentCategories.find((cat) => cat.slug === slug)?.children || [],
  );

  getBySlug(stationId, slug, { signal: abortController.signal })
    .then((res) => {
      if (!abortController.signal.aborted) {
        dispatch(setProducts(res));
      }
    })
    .catch((err) => {
      if (err.name === "AbortError") {
        console.log("Request aborted:", slug);
      } else {
        console.error("Error fetching category by slug:", err);
      }
    });

  const splitPath = pathname.split("/");
  const indexOf = splitPath.indexOf(fatherSlug);
  navigate(
    `${indexOf === -1 ? pathname : splitPath.slice(0, indexOf).join("/")}/${fatherSlug}/${slug}`,
  );
};
  useEffect(() => {
    return () => {
      if (currentAbortController.current) {
        currentAbortController.current.abort();
      }
    };
  }, []);  

  useEffect(() => {
    setChildren([]);
  }, [currentCategories]);

  return (
    <>
      <nav className={`sub-navbar level-${level}`}>
        <ScrollMenu
          LeftArrow={LeftArrow}
          RightArrow={RightArrow}
          RTL
          wrapperClassName="custom-scroll-wrapper"
          scrollContainerClassName="custom-scroll-container"
        >
          {currentCategories.map(
            (category) =>
              !category.isFamily && (
                <div
                  key={category.slug}
                  className={`sub-navbar-item ${category.slug === currentCategory || category.slug === currentSubCategory ? "active" : ""}`}
                  onClick={() => handleCategoryClick(category.slug)}
                >
                  {category.name}
                </div>
              )
          )}
        </ScrollMenu>
      </nav>
      {children.filter((cat) => !cat.isFamily).length !== 0 && (
        <SubNavbar
          fatherSlug={currentCategory}
          currentSubCategory={currentSubCategory}
          currentCategories={children}
          handleSubCategoryClick={handleSubCategoryClick}
          level={level + 1}
        />
      )}
    </>
  );
};

const ArrowButton = ({ children, disabled, onClick, className }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`custom-arrow-btn ${className}`}
    >
      {children}
    </button>
  );
};

const LeftArrow = () => {
  const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);
  return (
    <ArrowButton
      disabled={isLastItemVisible}
      onClick={() => scrollNext()}
      className="left-arrow"
    >
      <img
        src={globalFileIcon + "open-cart.svg"}
        alt="scroll left"
        className="rotate-90"
      />
    </ArrowButton>
  );
};

const RightArrow = () => {
  const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);
  return (
    <ArrowButton
      disabled={isFirstItemVisible}
      onClick={() => scrollPrev()}
      className="right-arrow"
    >
      <img
        src={globalFileIcon + "open-cart.svg"}
        alt="scroll right"
        className="rotate-270"
      />
    </ArrowButton>
  );
};

export default SubNavbar;
